// Configuración de variables de entorno para el frontend
export const config = {
  // API Configuration - Usar la IP pública para acceso desde internet
  API_URL: import.meta.env.VITE_API_URL || 'http://95.217.75.54:8060/api/v1',
  
  // Google OAuth Configuration
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || 'your-google-client-id-here',
  
  // Development Configuration
  DEV_MODE: import.meta.env.VITE_DEV_MODE === 'true' || import.meta.env.DEV,
  DEBUG: import.meta.env.VITE_DEBUG === 'true' || import.meta.env.DEV,
  
  // Nueva variable para controlar la visibilidad del modo desarrollador
  SHOW_DEVELOPER_MODE: import.meta.env.VITE_SHOW_DEVELOPER_MODE === 'true',
}

// Función para obtener la configuración
export const getConfig = () => config

// Función para validar la configuración
export const validateConfig = () => {
  const errors = []
  
  if (!config.API_URL) {
    errors.push('VITE_API_URL no está configurada')
  }
  
  if (!config.GOOGLE_CLIENT_ID || config.GOOGLE_CLIENT_ID === 'your-google-client-id-here') {
    errors.push('VITE_GOOGLE_CLIENT_ID no está configurada correctamente')
  }
  
  return errors
} 